const message = {
  required: 'form.error.required',
  email: 'form.error.invalid_email',
  minLength: 'form.error.min_length',
  maxLength: 'form.error.max_length',
  passwordInvalidString: 'form.error.password_invalid_string',
  passwordInvalidLength: 'form.error.password_invalid_length',
  passwordRepeatSameCharacter: 'form.error.password_repeat_same_character',
  passwordExistsEmail: 'form.error.password_exists_email',
  passwordAlphabetsSize: 'form.error.password_alphabet_size',
  passwordNumbersSize: 'form.error.password_number_size',
}

const Regex = {
  // eslint-disable-next-line no-useless-escape
  email: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@(?:[a-zA-Z0-9-]+\.)+(?:[a-zA-Z0-9-\.]{2,61})+$/,
  ip_address: /^(([1-9]?[0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([1-9]?[0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/[1-9]|\/(1|2)[0-9]|\/3[0-2])?$/,
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export const composeValidators = (...validators: any[]) => (value: any) => validators.reduce(
  (error, validator) => error || validator(value),
  undefined,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export const required = (label?: string) => (value: any): string | undefined => {
  if (value || typeof value === 'number') {
    return undefined
  }
  return label ? 'form.error.no_label' : message.required
}

export const email = (value: string): string | undefined => (value && !Regex.email.test(value) ? message.email : undefined)

export const minLength = (min: number) => (value: string): string | undefined => (value && value.length < min ? message.minLength : undefined)

export const maxLength = (max: number) => (value: string): string | undefined => (value && value.length > max ? message.maxLength : undefined)

const validatePasswordString = (value: string): boolean => /^[a-zA-Z0-9!"$-/;-@¥{-~]+$/.test(value)

const validatePasswordLength = (value: string): boolean => value.length < 8 || 64 < value.length

const validatePasswordRepeatSameCharacter = (value: string): string[] | null => value.match(/(.)\1\1/g)

const validatePasswordExistsLocalEmail = (value: string, allValuesEmail: string): number => {
  const emailLocal = allValuesEmail.split('@')
  return value.indexOf(emailLocal[0])
}

const validatePasswordExistsDomainEmail = (value: string, allValuesEmail: string): number => {
  const emailSplit = allValuesEmail.split('@')
  const emailDomain = emailSplit[1].split('.')
  return value.indexOf(emailDomain[0])
}

const validatePasswordAlphabetsSize = (pass: string): number => {
  const alphabets = pass.match(/[a-zA-Z]/g)
  return new Set(alphabets).size
}

const validatePasswordNumbersSize = (pass: string): number => {
  const numbers = pass.match(/[0-9]/g)
  return new Set(numbers).size
}

export const validateIpAddress = (value: string): boolean => Regex.ip_address.test(value)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export const password = (value: string, allValues: any): string[] | undefined => {
  if (!value) return undefined

  const errorMessage: string[] = []

  if (validatePasswordString(value) === false) {
    errorMessage.push(message.passwordInvalidString)
  }

  if (validatePasswordLength(value) === true) {
    errorMessage.push(message.passwordInvalidLength)
  }

  if (validatePasswordRepeatSameCharacter(value) !== null) {
    errorMessage.push(message.passwordRepeatSameCharacter)
  }

  if (allValues.email && allValues.email.includes('@')) {
    if (validatePasswordExistsLocalEmail(value, allValues.email) >= 0) {
      errorMessage.push(message.passwordExistsEmail)
    } else if (validatePasswordExistsDomainEmail(value, allValues.email) >= 0) {
      errorMessage.push(message.passwordExistsEmail)
    }
  }

  if (validatePasswordAlphabetsSize(value) < 2) {
    errorMessage.push(message.passwordAlphabetsSize)
  }

  if (validatePasswordNumbersSize(value) < 2) {
    errorMessage.push(message.passwordNumbersSize)
  }

  return errorMessage.length > 0 ? errorMessage : undefined
}
